import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

/* Slick Carousel SCSS imports */

import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";

import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
